import { PasswordRecoveryScreen } from '../screens';
export default PasswordRecoveryScreen;
